module.exports = __webpack_public_path__ + "static/circle-red-330dc9526c8dea69aa6e90b1ad4c43f7.png";